import React from "react";
import style from "./Metrics.module.scss";

export const Metrics = ({ messages }) => {
  if (!messages) return null;
  const renderBannerDetails = (words) => {
    return words.map((word, index) => (
      <div className={style.bannerDetail} key={index}>
        <span>{word.number}</span>
        <p>{word.text}</p>
      </div>
    ));
  };
  return (
    <div className={style.sectionContainer}>
      <div className={style.titleSlider}>
        <div className="container">
          <h3>{messages.subtitle}</h3>
        </div>
        <div className={`${style.sliderContainer} ${style.fadeoutHorizontal}`}>
          <div className={style.banner}>
            {renderBannerDetails(messages.sliderOne)}
            {renderBannerDetails(messages.sliderOne)}
          </div>
          <div className={`${style.banner} ${style.reverse}`}>
            {renderBannerDetails(messages.sliderTwo)}
            {renderBannerDetails(messages.sliderTwo)}
          </div>
        </div>
      </div>
    </div>
  );
};
